<template>
   <div class="crud-wrapper">
      <crud :filterBy="{filters: dataFilter}" :form-component="AffiliateForm" :grid-columns="gridColumns" :gridSettings="{noNew: true}"
            :grid-options="gridOptions" obj="backofficeAffiliate" :key="reRender">
      </crud>
   </div>
</template>

<script>
    import numeral from 'numeral';
    import PageClass from '@consigmais-team/vue-common/layout/defaultPage/pageClass';
    import AffiliateForm from './AffiliateForm';

    export default PageClass.extend({
        name: 'Affiliates',

        data() {
            return {
                AffiliateForm,
                reRender: 0,
                gridColumns: null,
                gridOptions: {},
                dataFilter: {},
            
                gridColumns: [
                    {
                        dataField: 'name',
                        caption: 'Nome',
                        minWidth: 120
                    },
                    {
                        dataField: 'federalId',
                        caption: 'CPF',
                        width: 50,
                        visible: false
                    },
                    {
                        dataField: 'mobileNumber',
                        caption: 'Fone',
                        minWidth: 90,
                        cellTemplate: (element, info) => {
                            let p = String(info.data.mobileNumber || '').replace('+55', '');
                            let f = this.$util.applyMask(p, (p.length > 10) ? '(99) 9 9999-9999' : '(##) ####-####');
                            $(`<span>${f}</span>`).appendTo(element);
                        }
                    },
                    {
                        dataField: 'birth',
                        caption: 'Nascimento',
                        dataType: 'date',
                        format: 'dd/MM/yyyy',
                        width: 110,
                        visible: false
                    },
                    {
                        dataField: 'city',
                        caption: 'Cidade'
                    },
                    {
                        dataField: 'state',
                        caption: 'Estado',
                        width: 70
                    },
                    {
                        dataField: 'createdAt',
                        caption: 'Data de Cadastro',
                        dataType:"date",
                        format: 'dd/MM/yyyy hh:mm',
                    },
                    {
                        dataField: 'leads',
                        caption: 'Leads'
                    },
                    {
                        dataField: 'amountSum',
                        caption: 'Produção',
                        dataType: 'number',
                        format: function (value) {
                            return numeral(value).format('0,0.' + '0'.repeat(2));
                        }
                    },
                    {
                        dataField: 'totalCommissionSum',
                        caption: 'Comissão',
                        dataType: 'number',
                        format: function (value) {
                            return numeral(value).format('0,0.' + '0'.repeat(2));
                        }
                    },
                    {
                        dataField: 'affiliateCommissionSum',
                        caption: 'Comissão Afiliado',
                        dataType: 'number',
                        format: function (value) {
                            return numeral(value).format('0,0.' + '0'.repeat(2));
                        }
                    },
                    {
                        dataField: 'level',
                        caption: 'Nível',
                        width: 80,
                        visible: false
                    },
                    {
                        dataField: 'affiliateQty',
                        caption: 'Sub-Afiliados',
                        width: 100
                    },
                    {
                        dataField: 'referralCode',
                        caption: 'Código',
                        width: 50,
                        visible: false
                    },
                ]
            };
        },

        created () {
            this.init();
        },

        methods: {
            pageFiltersChange (filters) {
                this.dataFilter = {
                    beginDate: filters.dateRange && filters.dateRange[0] ? filters.dateRange[0] : null,
                    endDate: filters.dateRange && filters.dateRange[1] ? filters.dateRange[1] : null,
                    productTypeId: filters.dateRange && filters.productTypeId ? filters.productTypeId : null
                };
            },

            async init() {
                if (!this.hasPageFilters) {
                    this.createPageFilters([
                        { field: 'productTypeId' },
                        { field: 'dateRange' }
                    ]);

                    // DEFAULTS FILTERS
                    this.setPageFilter(
                        'dateRange',
                        [
                            this.$util.dateRange.thisMonth.start(), this.$util.dateRange.thisMonth.end()
                        ],
                        'Entre {0} e {1}'.format(this.$util.dateRange.thisMonth.start('DD/MM/YYYY'), this.$util.dateRange.thisMonth.end('DD/MM/YYYY'))
                    );

                } else {
                    let filters = this.$store.getters.activePageFilters;
                    this.dataFilter = {
                        beginDate: filters.dateRange[0] ? filters.dateRange[0] : null,
                        endDate: filters.dateRange[1] ? filters.dateRange[1] : null,
                        productTypeId: filters.productTypeId ? filters.productTypeId : null
                    };

                }
            }
        } 
    });

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Affiliates.vue